<table class="w-full text-left rtl:text-right text-gray-500">
	<thead class="bg-emerald-500 text-white semi-bold sticky top-0 z-10">
		<tr>
			<th class="px-2 py-2 cursor-pointer" (click)="onSortClick({ column: 'LogDate', direction: sortConfig.direction })">
				Date
				<i [ngClass]="{ hidden: sortConfig.column !== 'LogDate' }" [class]="getSortIconClass('LogDate')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="onSortClick({ column: 'LogSubject', direction: sortConfig.direction })">
				Subject
				<i [ngClass]="{ hidden: sortConfig.column !== 'LogSubject' }" [class]="getSortIconClass('LogSubject')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="onSortClick({ column: 'LogMessage', direction: sortConfig.direction })">
				Notes
				<i [ngClass]="{ hidden: sortConfig.column !== 'LogMessage' }" [class]="getSortIconClass('LogMessage')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="onSortClick({ column: 'UserName', direction: sortConfig.direction })">
				Author
				<i [ngClass]="{ hidden: sortConfig.column !== 'UserName' }" [class]="getSortIconClass('UserName')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="onSortClick({ column: 'EntryType', direction: sortConfig.direction })">
				Type
				<i [ngClass]="{ hidden: sortConfig.column !== 'EntryType' }" [class]="getSortIconClass('EntryType')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="onSortClick({ column: 'EntrySource', direction: sortConfig.direction })">
				Device
				<i [ngClass]="{ hidden: sortConfig.column !== 'EntrySource' }" [class]="getSortIconClass('EntrySource')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="onSortClick({ column: 'Id', direction: sortConfig.direction })">
				ID
				<i [ngClass]="{ hidden: sortConfig.column !== 'Id' }" [class]="getSortIconClass('Id')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2">
				<i class="fas fa-pencil-alt"></i>
			</th>
			<th class="px-2 py-2">
				<i class="fas fa-trash-alt"></i>
			</th>
		</tr>
	</thead>
	<tbody>
		<tr
			*ngFor="
				let historyNote of historyNotesService.historyNotes
					| paginate
						: {
								itemsPerPage: 25,
								currentPage: historyNotesService.viewState.pageNumber,
								totalItems: historyNotesService.totalItems
						  }
			"
			class="bg-white border-b text-sm text-black"
		>
			<td class="py-2 px-2">
				<p class="flex items-center semi-bold">{{ historyNote.LogDate | date : 'short' }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ historyNote.LogSubject }}</p>
			</td>
			<td class="py-2 px-2 max-w-[700px]">
				<p class="" [innerHTML]="historyNote.LogMessage"></p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ historyNote.UserName }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ historyNote.EntryType }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ historyNote.EntrySource }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ historyNote.Id }}</p>
			</td>
			<td class="py-2 px-2">
				<button
					(click)="onEditClick(historyNote)"
					class="px-4 bg-gray-200 border border-gray-200 hover:bg-gray-300 focus:ring-gray-300 !w-auto !cursor-pointer focus:ring-4 focus:outline-none font-medium rounded text-sm px-2.5 py-2.5 text-center me-2"
				>
					Edit
				</button>
			</td>
			<td class="py-2 px-2">
				<button
					(click)="onDeleteClick(historyNote)"
					class="px-2 text-red-500 hover:text-white border border-red-500 hover:bg-red-700 focus:ring-red-300 !w-auto !cursor-pointer focus:ring-4 focus:outline-none font-medium rounded text-sm px-2 py-2.5 text-center me-2"
				>
					Delete
				</button>
			</td>
		</tr>
	</tbody>
</table>

<div *ngIf="historyNotesService.historyNotes?.length > 0" class="flex justify-between items-center mt-2 mb-[100px]">
	<div>
		<pagination-controls (pageChange)="onPageChange($event)" class="pagination"></pagination-controls>
		<input class="h-10 !w-16 mr-4" [(ngModel)]="historyNotesService.viewState.pageNumber" (input)="onPageChange()" />
	</div>
	<div *ngIf="historyNotesService.totalItems">
		<span class="semi-bold">Total Items:</span>
		{{ historyNotesService.totalItems }}
	</div>
</div>

<crm-history-note-edit-modal *ngIf="showEditModal" (handleExitClick)="onEditModalExit()"></crm-history-note-edit-modal>
